import React, { useState } from 'react';
import { Mail, CheckCircle } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const EmailCapture = ({ 
  source = "homepage", 
  title = "Join Our Community",
  subtitle = "Get updates on new debates, articles, and Free Grace theology content.",
  compact = false 
}) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API}/subscribe`, {
        email,
        name,
        source
      });

      setSuccess(true);
      setEmail('');
      setName('');
      
      // Reset success message after 5 seconds
      setTimeout(() => setSuccess(false), 5000);
    } catch (err) {
      setError('Failed to subscribe. Please try again.');
      console.error('Subscription error:', err);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className={`email-capture-success ${compact ? 'compact' : ''}`}>
        <CheckCircle size={compact ? 24 : 32} className="success-icon" />
        <div className="success-content">
          <h3 className={compact ? "heading-3" : "heading-2"}>Welcome to Praise I AM!</h3>
          <p className="body-medium">Check your email to confirm your subscription.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`email-capture-container ${compact ? 'compact' : ''}`}>
      <div className="email-capture-content">
        <div className="email-capture-header">
          <Mail size={compact ? 24 : 32} className="email-icon" />
          <div>
            <h3 className={compact ? "heading-3" : "heading-2"}>{title}</h3>
            {!compact && <p className="body-medium email-subtitle">{subtitle}</p>}
          </div>
        </div>

        <form onSubmit={handleSubmit} className="email-capture-form">
          {!compact && (
            <input
              type="text"
              placeholder="Your Name (Optional)"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="email-input"
            />
          )}
          
          <div className="email-input-group">
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="email-input"
            />
            <button 
              type="submit" 
              className="email-submit-btn"
              disabled={loading}
            >
              {loading ? 'Subscribing...' : 'Subscribe'}
            </button>
          </div>

          {error && <p className="email-error">{error}</p>}
        </form>

        {!compact && (
          <p className="email-disclaimer">
            We respect your privacy. Unsubscribe anytime.
          </p>
        )}
      </div>
    </div>
  );
};

export default EmailCapture;
